<div [class]="props.styleClass" class="b-f-text">
  <div
    [class]="props.clickable ? 'b-f-clickable' : ''"
    (click)="onClick($event)"
  >
    {{ props.text }}
  </div>
  <div
    *ngIf="props.tooltip"
    class="symbol-info tooltip-icon"
    [pTooltip]="props.tooltip"
  ></div>
</div>
